import React from 'react';
import { confirmable } from 'react-confirm';
import { Modal, Header, Button } from 'semantic-ui-react';

class Dialog extends React.Component{
  render() {
    const {show, proceed, dismiss, title, confirmation } = this.props;
    return (
      <Modal open={show} onClose={dismiss}>
        <Header content={title} />
        <Modal.Content>
          <p className='break-lines'>
            {confirmation}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' inverted onClick={proceed} content='OK' />
        </Modal.Actions>
      </Modal>
    );
  }
};

export default confirmable(Dialog);
